import { Component, OnInit} from "@angular/core";
import {UntypedFormBuilder,UntypedFormGroup,UntypedFormArray} from "@angular/forms";
import { WelcomeScreenService } from "./welcomeScreen.service";
import { BaseCRUDComponent } from "../../Core/Abstract/baseCRUD.component";
import { LogService } from "../../Core/Abstract/log.service";
import { VisualsService } from "../../Core/Abstract/visuals.service";
import { ActivatedRoute, Router } from "@angular/router";
import { FormlyFormOptions, FormlyFieldConfig } from '@ngx-formly/core';
import { SecurityService } from '../../Core/Security/security.service';
import { EventsEmitterService } from "../../Core/Abstract/emitter.service";
import { forkJoin } from "rxjs";
import { Subscription } from 'rxjs';
import { ConfigService } from '../../Core/Abstract/config.service';

@Component({
  selector: "welcomeScreen-grid",
  templateUrl: "./welcomeScreen.component.html",
  providers: [WelcomeScreenService]
})    
export class WelcomeScreenComponent extends BaseCRUDComponent<WelcomeScreenService>implements OnInit {
  form :any;
  options: FormlyFormOptions = {};
  model;
  ob:any;
  termsTemplate:any;
  clusterTerms:any;
  subscription: Subscription;
  subscriptionSubmit: Subscription;
  fields;
  userId: any;
  isOrigin: any;
  hasBackGround: any;
  loading: boolean = false;
  buyerCompanyInfo:any;
  protected profile: string = 'demo';
  bearer:string='';
  
  constructor(
    private securityService: SecurityService,
    private service: WelcomeScreenService,
    private configService:ConfigService,
    private eventsEmitterService: EventsEmitterService,
    fb: UntypedFormBuilder,
    logger: LogService,
    visualsService: VisualsService,
    route: ActivatedRoute,
    router: Router
  ) {
    super(logger, visualsService, route, fb, router);
    this.group = "welcomeScreen";
    this.loadVisuals();
    this.userId = this.route.snapshot.queryParamMap.get('userId');
    this.ob = this.route.snapshot.queryParamMap.get('ob');
    this.isOrigin = this.route.snapshot.queryParamMap.get('isOrigin');
    this.getFormConfigAndData();
    this.profile = this.configService.getClient();
    this.eventsEmitterService.languageChange.subscribe(langId => {
      this.getTerms();
      this.loadVisuals();
    });
  }
  getFormConfigAndData(){
     
    this.loading = true;
    this.subscription = forkJoin( this.service.getFields(this.userId), 
                                  this.service.loadBean(this.userId),
                                  this.visualsService.getParam('WELCOME_SCREEN_BACKGROUND'),
                                  this.service.getTermsFormlyCluster(this.userId),
                                  this.service.getBuyerCompany(this.userId)).subscribe(
        response =>{ 
          this.fields = this.mapFields(JSON.parse(response[0].data.valForm)).fields;
          this.form = new UntypedFormArray(this.fields.map(() => new UntypedFormGroup({})));
          this.hasBackGround = response[2].paramValStr; 
          this.clusterTerms = JSON.parse(response[3].data);
          localStorage.setItem("cluster",response[3].data);
          this.buyerCompanyInfo = response[4].data;
          this.getInterestBearer();
          if(this.hasBackGround == 'Y'){
            let url = '/assets/images/logo/'+this.configService.getClient()+'/welcome-screen.png';
            document.querySelector("body").style.backgroundImage = "url("+url+")";
            document.querySelector("body").style.backgroundSize = "cover";
            document.querySelector("body").style.backgroundPosition = "center";
            document.querySelector("body").style.backgroundRepeat = "no-repeat";
          }
          if(response[1].data){
            let arrayToObject = JSON.parse(response[1].data.dataChar);
            this.model = Object.assign({}, ...arrayToObject);
            if(this.model.isAgreed == 'Y' && !this.ob){
                this.securityService.router.navigate(['/menu/onboard'], {queryParams: {userId: this.userId,isOrigin:this.isOrigin}});
              }else{
                this.getTerms()
              }
          }
          else{
            this.getTerms()
          }
          this.loading = false
        },
        error => console.log("Error: ", error),
    )
  }
  getTerms(){
    if(!this.clusterTerms)
        return;
    this.loading = true;
    let onboardingTemplate = (this.clusterTerms.onboardingType == '_Basic' || this.clusterTerms.onboardingType == '_Cards') ? 'ONBOARDING_TERMS_TEMPLATE': 'ONBOARDING_ALT_TERMS_TEMPLATE';    
    this.service.getTerms(onboardingTemplate).subscribe((res) => {
      this.termsTemplate = res.data.valLabel.replace(/{{([^}}]+)?}}/g, ($1, $2) => 
      $2.split('.').reduce((p, c) => p ? p[c] : '', this));
      this.loading = false
    },
    error => {
      this.loading = false;
      this.logger.error(error);
    });
  
  }
    submit(){
      if (!this.form.valid) {
        return
      }
      let formToSend = this.form.value
      formToSend[0].isAgreed = 'Y';
      this.loading = true;
      this.subscriptionSubmit = forkJoin(this.service.validate(formToSend,this.userId),this.service.save(formToSend,this.userId)).subscribe(
          response =>{
            if (response[0].success) {
              const type = response[0].data.validateCustomerType;
              if ((type === 'BANK_CUSTOMER' || type === 'SCF_CUSTOMER_OTP') ) {
                localStorage.setItem('welcomeFormData', JSON.stringify(formToSend));
                localStorage.setItem('timerSeconds', response[0].data.otpTimer);
                this.securityService.router.navigate(['/menu/validate'], {queryParams: {userId: this.userId,crsId:response[0].data.crsId,type: type,uuid: response[0].data.uuid}});
                LogService.emitAlert({
                      type: "success",
                      body: this.genericVisuals.otpGenerated
                });
              }else{
                this.securityService.router.navigate(['/menu/onboard'], {queryParams: {userId: this.userId,isOrigin:this.isOrigin}});
                    LogService.emitAlert({
                      type: "success",
                      body: this.genericVisuals.dataSaved
                });
              }
            }else{
              this.securityService.router.navigate(['/menu/onboard'], {queryParams: {userId: this.userId,isOrigin:this.isOrigin}});
                  LogService.emitAlert({
                    type: "success",
                    body: this.genericVisuals.dataSaved
              });
            }
            this.loading = false;
          },
          error => {
            this.loading = false;
            console.log("Error: ", error)
          },
          () =>{
            this.getTerms();
            this.loading = false;
          }
      )

    }
    ngOnDestroy() {
      this.subscription.unsubscribe();
    }

    getInterestBearer(){
      
      switch (this.clusterTerms.discountingCharge) {
        case 'S':
          this.bearer = this.clusterTerms.supplierName;
          break;
        case 'B':
          this.bearer = this.buyerCompanyInfo.buyerCompanyNme;
          break;
        case 'BO':
          this.bearer = `${this.clusterTerms.supplierName} / ${this.buyerCompanyInfo.buyerCompanyNme}`;
          break;
        default:
          this.bearer = 'Unknown';
          break;
      }
    }
  }

  
